import React, { useState, useEffect } from 'react';
import { TbArrowsExchange } from "react-icons/tb";
import { RxCaretDown } from "react-icons/rx";
import './converter.css'; 
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchWallets, swapCurrencyPreview, transferFundsSummary } from '../../actions/payments';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'bootstrap';
import swapIcon from '../../assets/img/icon/card_verve-card.png';
import sendIcon from '../../assets/img/icon/card_credit-card.png';
import chooseCardIcon2 from '../../assets/img/icon/card_credit-card.png';
import { toast } from 'react-toastify';
import { getAuthenticatedUser } from '../../actions/auth';
import { fetchExchangeRates } from '../../redux/slices/countriesSlice';
import { formatAmount, getCurrencyInfoByCountryCode, getCurrencyInfoByCurrencyCode, getFlagUrl, dataURLtoFile } from '../../helpers/currency';
import { handleValidationError } from '../../actions/validation';


const cardOptions = [
  { id: 1, slug: 'swap', name: 'Swap Currency', description: 'Convert between currencies instantly at great rates.', icon: swapIcon },
  { id: 2, slug: 'send', name: 'Send Money', description: 'Send funds locally or internationally with ease.', icon: sendIcon },
];
const selectedTransferLocation = { id: 2, slug: "international", name: "International Transfer", description: "Easily transfer money across borders with competitive rates and global reach.", icon: chooseCardIcon2 }

const CurrencyExchangeComponent = ({ sendMoneyPage = false, payload, txnAmountDetails, setIsTxnDetailsEdited, setTxnAmountDetails }) => {
  const userDetails = useSelector((state) => state.user.user);
  const location = useLocation();
  const isLoggedIn = userDetails !== null && userDetails.email;
  const backToCalDefault = location.state?.backToCalDefault;
  const { currencyOptions, conversionRates } = useSelector((state) => state.country);

  const isBankTransfer = payload?.transfer_type === 'bank';
  const isSendMoneyPage = location.pathname.includes('user/send_money');
  
  const senderCurrencyCodeFromPayload = payload?.fundingSource?.currency_code;
  const [senderCountry, setSenderCountry] = useState(null);
  const [sendCurrency, setSendCurrency] = useState(senderCurrencyCodeFromPayload);
  const [primaryWalletCurrency, setPrimaryWalletCurrency] = useState(userDetails?.default_wallet?.currency_code || 'NGN');
  
  const recipientCountryCode = payload?.recipient?.recipientCountry?.toUpperCase();
  const payloadReceivingCurrencyCode = payload?.recipient?.recipientCurrencyCode;
  const recipientCurrencyCode = payloadReceivingCurrencyCode || getCurrencyInfoByCountryCode(currencyOptions, recipientCountryCode)?.currencyCode;
  const [receiverCountry, setReceiverCountry] = useState(null);
  const [receiveCurrency, setReceiveCurrency] = useState(recipientCurrencyCode);
  
  // const localTransferType = payload?.location?.slug === "local" ? true : false;
  const localTransferType = sendCurrency == receiveCurrency;

  const [sendAmount, setSendAmount] = useState(0);
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(0);
  
  const [showSendDropdown, setShowSendDropdown] = useState(false);
  const [showReceiveDropdown, setShowReceiveDropdown] = useState(false);
  
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [userWallets, setUserWallets] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [txnAmountInfo, setTxnAmountInfo] = useState();
  const [lastEdited, setLastEdited] = useState('send'); // or 'receive'

  useEffect(() => {
    if (isSendMoneyPage && sendCurrency && receiveCurrency) {
      const transactionDetailsInfo = {
        sendCurrency,
        receiveCurrency,
        sendAmount,
        receiveAmount
      };
      setTxnAmountDetails(transactionDetailsInfo);
    }
  }, [sendCurrency, receiveCurrency, sendAmount, receiveAmount]);

  const fetchAllWallets = async () => {
      setLoading(true);
      try {
        const response = await fetchWallets();
        const wallets = response.data.wallets.wallets;
        setUserWallets(wallets);
        wallets.forEach(function(wallet){
          if(wallet.is_primary) setPrimaryWalletCurrency(wallet.currency_code)
        });
      } catch (error) {
        // console.error("Error fetching wallets:", error);
      } finally {
        setLoading(false);
      }
  };
  
  useEffect(() => {
    fetchAllWallets();
    dispatch(fetchExchangeRates());
  }, []);

  useEffect(() => {
    if (txnAmountDetails) {
      if (txnAmountDetails.sendCurrency) setSendCurrency(txnAmountDetails.sendCurrency);
      if (txnAmountDetails.receiveCurrency) setReceiveCurrency(txnAmountDetails.receiveCurrency);
      if (txnAmountDetails.sendAmount !== undefined && txnAmountDetails.sendAmount !== null) {
        setSendAmount(txnAmountDetails.sendAmount);
      }
      if (txnAmountDetails.receiveAmount !== undefined && txnAmountDetails.receiveAmount !== null) {
        setReceiveAmount(txnAmountDetails.receiveAmount);
      }
    }
  }, [txnAmountDetails]);

  // display converter in default mode
  useEffect(() => {
    if (backToCalDefault) {
      if (backToCalDefault.sendCurrency && (!isSendMoneyPage ? backToCalDefault.sendCurrency !== primaryWalletCurrency : true)) {
        setSendCurrency(backToCalDefault.sendCurrency);
      }
      if (isSendMoneyPage && backToCalDefault.receiveCurrency) {
        setReceiveCurrency(backToCalDefault.receiveCurrency);
      }
      if (backToCalDefault.sendAmount !== undefined && backToCalDefault.sendAmount !== null) {
        setSendAmount(backToCalDefault.sendAmount);
      }
      if (backToCalDefault.receiveAmount !== undefined && backToCalDefault.receiveAmount !== null) {
        setReceiveAmount(backToCalDefault.receiveAmount);
      }
    }
  }, [backToCalDefault, isSendMoneyPage, primaryWalletCurrency]);

  const findRate = (from, to) => {
    if (from === to) return 1;
    
    const normalizeCode = (c) => (c === 'CHY' ? 'CNY' : c);
    const fromNorm = normalizeCode(from);
    const toNorm = normalizeCode(to);

    const fromData = conversionRates.find(r => normalizeCode(r.currency_code) === fromNorm);
    const toData = conversionRates.find(r => normalizeCode(r.currency_code) === toNorm);
    if (!fromData || !toData) return 0;
    
    const fromBuyRate = parseFloat(fromData.buy_rate);
    const toSellRate = parseFloat(toData.sell_rate);
    return toSellRate / fromBuyRate;
  };

  useEffect(() => {
    if (sendCurrency && receiveCurrency && conversionRates?.length > 0) {
      const rate = findRate(sendCurrency, receiveCurrency);
      if (rate === 0) {
        toast.error(`No conversion rate found for ${sendCurrency} to ${receiveCurrency}`);
        setExchangeRate(0);
        setReceiveAmount("0.00");
        return;
      }

      setExchangeRate(
        rate > 0.1 ? rate.toFixed(4) :
        rate > 0.01 ? rate.toFixed(6) : 
        rate.toFixed(8)
      );
      if (lastEdited === 'send') {
        const receiveAmountInCents = Math.floor((sendAmount * rate) * 100);
        setReceiveAmount(receiveAmountInCents/100);
      } else if (lastEdited === 'receive') {
        const sendingAmountInCents = Math.ceil(receiveAmount * 100/rate);
        setSendAmount(sendingAmountInCents/100);
      }
    }
  }, [sendCurrency, receiveCurrency, sendAmount, receiveAmount, conversionRates, lastEdited]);

  const handleCurrencySwapBtn = () => {
    setSendCurrency(prev => {
      setReceiveCurrency(prev);
      return receiveCurrency;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSendDropdown || showReceiveDropdown) {
        if (!event.target.closest('.currency-selector')) {
          setShowSendDropdown(false);
          setShowReceiveDropdown(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSendDropdown, showReceiveDropdown]);

  
  const handleContinue = async () => {
    const isChinaTransfer = payload?.recipient?.recipientCountry === 'CN' || payload?.currency_to_send;
    const destinationCountryCurrency = isChinaTransfer ? 'CNY' : receiveCurrency;

    let credentials = {
      amount: receiveAmount,
      from_amount: sendAmount,
      recipient_id: payload?.recipient?.recipient_id,
      transfer_type: payload?.transfer_type,
      wallet_id: payload?.fundingSource?.id, 
      currency: destinationCountryCurrency,
      ...(payload?.currency_to_send ? { currency_to_send: payload.currency_to_send } : {}),
      ...(payload?.transferPurpose ? { purpose: payload.transferPurpose.value } : {}),
      ...(payload?.transferRecipientType ? { recipient_type: payload.transferRecipientType.value } : {}),
      ...(payload?.transferRecipientRelationship ? { recipient_relationship: payload.transferRecipientRelationship.value } : {}),
    };
    
    if (payload?.transfer_type !== 'cardplot') {
      credentials = {
        ...credentials,
        bank_details: {
          bank_id: payload?.recipient?.bank_uuid,
          account_number: payload?.recipient?.accountNumber,
          account_name: payload?.recipient?.username || payload?.recipient?.accountName,
        },
        ...(payload?.transactionDescription ? { narration: payload?.transactionDescription } : {}),
      };
    }

    const invoiceFile = payload?.invoice_document_file || dataURLtoFile(payload?.invoice_document || payload?.transferDocument, payload?.invoiceDocumentName || payload?.transferDocumentName);

    let finalPayload = credentials;
    if (invoiceFile) {
      const formData = new FormData();
      Object.keys(credentials).forEach((key) => {
        if (key === 'bank_details' && typeof credentials[key] === 'object' && credentials[key] !== null) {
          Object.keys(credentials.bank_details).forEach((subKey) => {
            if (credentials.bank_details[subKey] !== undefined && credentials.bank_details[subKey] !== null) {
              formData.append(`bank_details[${subKey}]`, credentials.bank_details[subKey]);
            }
          });
        } else if (credentials[key] !== undefined && credentials[key] !== null) {
          formData.append(key, credentials[key]);
        }
      });
      formData.append('invoice_document', invoiceFile);
      finalPayload = formData;
    }

    setLoading(true);

    try {
      const data = await transferFundsSummary(finalPayload);
      // console.log(data);
      let sendMoneyOverview
      
      const transactionFeesObj = typeof data?.summary?.transaction_fees === 'object' && data?.summary?.transaction_fees !== null ? data.summary.transaction_fees : null;
      
      // if (payload?.transfer_type === 'cardplot') {
      sendMoneyOverview = {
        sendCurrency: data?.wallet?.currency_code,
        receiveCurrency: data?.target_currency,
        sendAmount: data?.summary?.amount_sending || data?.summary?.wallet_debit_breakdown?.amount_to_convert,
        receiveAmount: data?.summary?.recipient_receives,
        exchangeRateAdmin: data?.summary?.exchange_rate_text || data?.summary?.exchange_rate,
        rawExchangeRate: data?.summary?.exchange_rate || 1,
        fee: transactionFeesObj ? transactionFeesObj.total_amount : data?.summary?.transaction_fees,
        fee_currency: transactionFeesObj ? transactionFeesObj.currency : data?.summary?.transaction_fees_currency,
        appliedFees: transactionFeesObj ? transactionFeesObj.applied_fees : null,
        totalAmount: data?.summary?.total_debit_amount,
        userWalletBalance: data?.summary?.wallet_total_balance || data?.wallet?.balance,
        remainingWalletBalance: data?.summary?.balance_after_payment,
        totalFees: transactionFeesObj ? transactionFeesObj.total_amount : data?.summary?.transaction_fees,
        sessionId: data?.session_id,
      };
      if(payload?.transfer_type !== 'cardplot'){
        sendMoneyOverview = {
          ...sendMoneyOverview,
          recipientBankAccount: data?.summary?.recipient_bank_account,
          totalStatutoryFees: data?.summary?.total_statutory_fees,
          appliedStatutoryFees: data?.summary?.applied_statutory_fees,
        };
      }
      const sendMoneyDetails = {
        sendCurrency,
        receiveCurrency,
        sendAmount,
        receiveAmount,
        exchangeRate,
        payload,
      };
      
      navigate('/user/send_money/step3', { state: { sendMoneyDetails, txnAmountDetails, sendMoneyOverview } }); 
    } catch (error) {
      handleValidationError(error, toast, "Error processing transaction");
    } finally {
      setLoading(false);
    }
  };
  
  const handleSendMoneyClick = async () => {
    const userHasCurrencyWallet = userWallets.some(wallet => wallet.currency_code === sendCurrency);
    
    if (!userHasCurrencyWallet) {
      toast.error('You do not have a wallet for the selected currency.');
      return;
    }
    
    const modalElement = document.getElementById('selectActionCardModal');
    const bsModal = Modal.getInstance(modalElement) || new Modal(modalElement);
    bsModal.hide();
    document.body.classList.remove('modal-open');
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

    const converterDetails = {
      sendCurrency,
      receiveCurrency,
      sendAmount,
      receiveAmount,
      exchangeRate,
      isFromConverter: false,
    }
    if (selectedOption === 'swap') {
      const credentials = {
        from_currency: sendCurrency,
        to_currency: receiveCurrency,
        amount: sendAmount,
      }
      try {
        const response = await swapCurrencyPreview(credentials);
        
        const exchangeOverview = {...response.data.exchange};

        navigate('/user/currency_swap', { state: { converterDetails, exchangeOverview } });
      } catch (error) {
        handleValidationError(error, toast, 'Error fetching conversion rates')
        return;          
      }
    } else if (selectedOption === 'send') {
      navigate('/user/send_money/step1', { state: { converterDetails: {...converterDetails, isFromConverter: true}, selectedTransferLocation } });
    }
  }

  const handleSendMoneyBtnClick = (e) => {
    e.preventDefault();
  
    if (isLoggedIn) {
      const modalElement = document.getElementById('selectActionCardModal');
      const bsModal = Modal.getInstance(modalElement) || new Modal(modalElement);
      bsModal.show();
    } else {
      toast.warn('You must be logged in to send money.');
      navigate('/user/send_money');
    }
  }

  useEffect(() => {
    const userCurrencyCode = getCurrencyInfoByCountryCode(currencyOptions, userDetails?.country_code)?.currencyCode;
    const senderCurrencyCode = payload?.fundingSource?.currency_code || (userCurrencyCode == 'NGN' ? 'GHS' : 'NGN') || 'NGN';
    setSenderCountry(getCurrencyInfoByCurrencyCode(currencyOptions, senderCurrencyCode));
    setSendCurrency(senderCurrencyCode);

    const defaultReceivingCurrency = userCurrencyCode; //senderCurrencyCode != 'MWK' ? (userCurrencyCode || 'MWK') : 'NGN';
    const recipientCountryCode = payload?.recipient?.recipientCountry?.toUpperCase();
    const recipientCurrencyCode = getCurrencyInfoByCountryCode(currencyOptions, recipientCountryCode)?.currencyCode || defaultReceivingCurrency;
    setReceiverCountry(getCurrencyInfoByCurrencyCode(currencyOptions, recipientCurrencyCode));
    setReceiveCurrency(recipientCurrencyCode);
  }, [currencyOptions])

  useEffect(() => {
    if (!isSendMoneyPage && primaryWalletCurrency) {
      setReceiveCurrency(primaryWalletCurrency);
      setReceiverCountry(getCurrencyInfoByCurrencyCode(currencyOptions, primaryWalletCurrency));
      if (sendCurrency === primaryWalletCurrency) {
        const otherCurrency = currencyOptions?.find(c => c.currencyCode !== primaryWalletCurrency)?.currencyCode || 'GHS';
        setSendCurrency(otherCurrency);
        setSenderCountry(getCurrencyInfoByCurrencyCode(currencyOptions, otherCurrency));
      }
    }
  }, [primaryWalletCurrency, isSendMoneyPage, currencyOptions]);

  useEffect(() => {
    setSenderCountry(getCurrencyInfoByCurrencyCode(currencyOptions, sendCurrency));
    setReceiverCountry(getCurrencyInfoByCurrencyCode(currencyOptions, receiveCurrency));
  }, [sendCurrency, receiveCurrency])

  return (
    <div className={`currency-exchange-container ${sendMoneyPage ? 'send-money-page' : ''}`}>
      <div className="exchange-header">
        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted small">You send exactly</span>
          {(!localTransferType || !isSendMoneyPage) && <span className="text-muted small">Recipient receives</span>}
        </div>
        
        <div className="exchange-input-container" style={{ gridTemplateColumns : (localTransferType && isSendMoneyPage) ? '1fr' : '49% 49%' }}>
          {/* Send Currency Section */}
          <div className="currency-field send-field">
            <div className="currency-selector">
              <button 
                className="currency-select-btn"
                onClick={() => setShowSendDropdown(!showSendDropdown)}
                disabled={isSendMoneyPage}
              >
                <img src={getFlagUrl(senderCountry?.countryCode)}  alt=""  className="currency-flag" />
                <span className="currency-code">{currencyOptions.length > 0 && sendCurrency}</span>
                {!isSendMoneyPage && <RxCaretDown color='#0A95FF' />}
              </button>
              
              {showSendDropdown && (
                <div className="currency-dropdown">
                  {(isSendMoneyPage ? currencyOptions : currencyOptions?.filter(currency => currency.currencyCode !== primaryWalletCurrency)).map(currency => (
                    <div 
                      key={currency.currencyCode} 
                      className={`currency-option ${currency.currencyCode === sendCurrency ? 'selected' : ''}`}
                      onClick={() => {
                        setSendCurrency(currency.currencyCode);
                        setShowSendDropdown(false);
                      }}
                    >
                      <img src={currency.flagUrl} alt="" className="currency-flag" />
                      <span>{currency.country}</span>
                      <span>{currency.currencyCode}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <input
              type="text"
              value={sendAmount !== undefined && sendAmount !== null ? sendAmount.toLocaleString() : ''}
              onChange={(e) => {
                const value = e.target.value.replace(/,/g, '');
                if (!isNaN(value) && value !== '') {
                  setLastEdited('send');
                  setSendAmount(parseFloat(value));
                } else if (value === '') {
                  setSendAmount(0);
                }
              }}
              className="amount-input"
            />
          </div>
          
          {/* Swap Button */}
          {/* {!isSendMoneyPage && (
            <div className="swap-button" onClick={handleCurrencySwapBtn}>
              <i className="swap-icon"><TbArrowsExchange size={20} /></i>
            </div>
          )} */}
          
          {/* Receive Currency Section */}
          {(!localTransferType || !isSendMoneyPage) && (
            <div className="currency-field receive-field">
              <div className="currency-selector">
                <button 
                  type="button"
                  className="currency-select-btn"
                  onClick={() => {
                    if (isSendMoneyPage && !localTransferType) {
                      setShowReceiveDropdown(!showReceiveDropdown);
                    }
                  }}
                  disabled={!isSendMoneyPage}
                  style={!isSendMoneyPage ? { cursor: 'default', pointerEvents: 'none' } : {}}
                  title={!isSendMoneyPage ? `Conversion is locked to your primary wallet currency (${primaryWalletCurrency})` : ""}
                >
                  <img src={getFlagUrl(receiverCountry?.countryCode || (receiveCurrency === 'USD' ? 'US' : receiveCurrency === 'CNY' ? 'CN' : ''))} alt="" className="currency-flag"/>
                  <span className="currency-code">{receiveCurrency}</span>
                  {(isSendMoneyPage && !localTransferType) && <RxCaretDown color='#0A95FF' />}
                </button>
                
                {showReceiveDropdown && isSendMoneyPage && (
                  <div className="currency-dropdown">
                    {(localTransferType ? currencyOptions : currencyOptions?.filter(currency => currency.currencyCode !== sendCurrency)).map(currency => (
                      <div 
                        key={currency.currencyCode} 
                        className={`currency-option ${currency.currencyCode === receiveCurrency ? 'selected' : ''}`}
                        onClick={() => {
                          setReceiveCurrency(currency.currencyCode);
                          setShowReceiveDropdown(false);
                        }}
                      >
                          <img src={currency.flagUrl} alt="" className="currency-flag" />
                          <span>{currency.country}</span>
                          <span>{currency.currencyCode}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <input
                type="text"
                value={receiveAmount !== undefined && receiveAmount !== null ? receiveAmount.toLocaleString() : ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, '');
                  if (!isNaN(value) && value !== '') {
                    setLastEdited('receive');
                    setReceiveAmount(parseFloat(value));
                  } else if (value === '') {
                    setReceiveAmount(0);
                  }
                }}
                className="amount-input"
              />
            </div>
          )}
        </div>
      </div>
      
      {/* Exchange Information */}
      <div className="exchange-details">
        {!localTransferType && (
          <div className="detail-row">
            <span className="detail-label">Exchange rate</span>
            <span className="detail-value">
              {senderCountry?.symbol}1.00 ≈ {receiverCountry?.symbol}{exchangeRate}
            </span>
          </div>
        )}
        
        <div className="detail-row">
          <span className="detail-label">You send exactly</span>
          <span className="detail-value">
            {senderCountry?.symbol}{formatAmount(sendAmount)}
          </span>
        </div>
                
        <div className="detail-row">
          <span className="detail-label">Recipient will receive</span>
          <span className="detail-value">
            {receiverCountry?.symbol}{formatAmount(receiveAmount)}
          </span>
        </div>
      </div>
      
      {/* Send Money Button */}
      {!sendMoneyPage ? (
        <>
          <button onClick={handleSendMoneyBtnClick} className="primary__btn send-money-btn">
            Send Money
          </button>

          {/* <!-- Modal --> */}
          <section className="modal fade" id="selectActionCardModal" tabIndex="-1" aria-labelledby="selectActionCardModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                      <div className="d-flex justify-content-end pe-3 pt-3">
                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body mb-5 mx-4">
                        <h4 className="text-center mb-5">What would you like to do?</h4>

                        <div className="card-selection-container">
                          {cardOptions.map((card) => (
                            <div
                              key={card.id}
                              className={`card-option ${selectedOption === card.slug ? "active" : ""}`}
                              onClick={() => setSelectedOption(card.slug)}
                            >
                              <img src={card.icon} alt={card.name} className="card-icon mt-2" width="40px" height="40px" />
                              <h5 className="card-title">{card.name}</h5>
                              <p className="card-description">{card.description}</p>
                              <div className="radio-button">
                                <div className={`radio-dot ${selectedOption === card.slug ? "checked" : ""}`} />
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="d-flex align-items-center gap-3 justify-content-between mt-5">
                            <button className="btn primary__btn__outline w-50" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                            <button className="btn primary__btn w-50" onClick={handleSendMoneyClick}>Continue</button>
                        </div>
                    </div>
                  </div>
              </div>
          </section>
        </>
      ) : (
        <div className="d-flex align-items-center justify-content-center mt-3">
          <button onClick={handleContinue} className="btn primary__btn w-100 py-2" disabled={loading}>
            {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
                "Continue"
            )}
          </button>
        </div>
      )}
      {sendCurrency != receiveCurrency &&
        <p className="disclaimer-text">
          Exchange rates are dynamic. Always remember to check the applicable rate in-app before carrying out your exchange.
        </p>
      }
    </div>
  );
};

export default CurrencyExchangeComponent;